import { FirebaseOptions } from '@angular/fire/app';
export const dataAccessOptions: FirebaseOptions = {
  apiKey: 'AIzaSyC_xYS5_BoMPyqn3sdMQ_RdmVq84Q3nXOI',
  authDomain: 'rollapolla-v1.firebaseapp.com',
  projectId: 'rollapolla-v1',
  storageBucket: 'rollapolla-v1.appspot.com',
  messagingSenderId: '368144624370',
  appId: '1:368144624370:web:a29654bf620dd22a1ebe6b',
  measurementId: 'G-6ZM8TB6QCY',
};
